package com.wintermar.inspection.composeApp

import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.AfterVersion
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.wintermar.inspection.AnswerChunkFileTableQueries
import com.wintermar.inspection.AnswerFileTableQueries
import com.wintermar.inspection.AnswerLocationTableQueries
import com.wintermar.inspection.AnswerSelectionTableQueries
import com.wintermar.inspection.AnswerTableQueries
import com.wintermar.inspection.AppDatabase
import com.wintermar.inspection.InspectionTableQueries
import com.wintermar.inspection.SqliteVersionQueries
import com.wintermar.inspection.TemplateOptionTableQueries
import com.wintermar.inspection.TemplatePageSectionQuestionTableQueries
import com.wintermar.inspection.TemplatePageSectionTableQueries
import com.wintermar.inspection.TemplatePageTableQueries
import com.wintermar.inspection.TemplateTableQueries
import com.wintermar.inspection.VesselTableQueries
import kotlin.Long
import kotlin.Unit
import kotlin.reflect.KClass

internal val KClass<AppDatabase>.schema: SqlSchema<QueryResult.Value<Unit>>
  get() = AppDatabaseImpl.Schema

internal fun KClass<AppDatabase>.newInstance(driver: SqlDriver): AppDatabase = AppDatabaseImpl(driver)

private class AppDatabaseImpl(
  driver: SqlDriver,
) : TransacterImpl(driver),
    AppDatabase {
  override val answerChunkFileTableQueries: AnswerChunkFileTableQueries =
      AnswerChunkFileTableQueries(driver)

  override val answerFileTableQueries: AnswerFileTableQueries = AnswerFileTableQueries(driver)

  override val answerLocationTableQueries: AnswerLocationTableQueries =
      AnswerLocationTableQueries(driver)

  override val answerSelectionTableQueries: AnswerSelectionTableQueries =
      AnswerSelectionTableQueries(driver)

  override val answerTableQueries: AnswerTableQueries = AnswerTableQueries(driver)

  override val inspectionTableQueries: InspectionTableQueries = InspectionTableQueries(driver)

  override val sqliteVersionQueries: SqliteVersionQueries = SqliteVersionQueries(driver)

  override val templateOptionTableQueries: TemplateOptionTableQueries =
      TemplateOptionTableQueries(driver)

  override val templatePageSectionQuestionTableQueries: TemplatePageSectionQuestionTableQueries =
      TemplatePageSectionQuestionTableQueries(driver)

  override val templatePageSectionTableQueries: TemplatePageSectionTableQueries =
      TemplatePageSectionTableQueries(driver)

  override val templatePageTableQueries: TemplatePageTableQueries = TemplatePageTableQueries(driver)

  override val templateTableQueries: TemplateTableQueries = TemplateTableQueries(driver)

  override val vesselTableQueries: VesselTableQueries = VesselTableQueries(driver)

  public object Schema : SqlSchema<QueryResult.Value<Unit>> {
    override val version: Long
      get() = 8

    override fun create(driver: SqlDriver): QueryResult.Value<Unit> {
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS AnswerChunkFileTable (
          |   id TEXT PRIMARY KEY NOT NULL,
          |   answerFileId TEXT NOT NULL,
          |   fileName TEXT,
          |   originalFileName TEXT,
          |   chunkIndex INTEGER,
          |   chunk BLOB,
          |   fileSize INTEGER,
          |   chunkSize INTEGER,
          |   totalFiles INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS AnswerFileTable (
          |   id TEXT PRIMARY KEY NOT NULL,
          |   answerId TEXT NOT NULL,
          |   name TEXT NOT NULL,
          |   originalName TEXT,
          |   path TEXT,
          |   size INTEGER,
          |   type TEXT,
          |   blob BLOB,
          |   uploadStatus TEXT
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS AnswerLocationTable (
          |   id TEXT PRIMARY KEY NOT NULL,
          |   answerId TEXT NOT NULL,
          |   name TEXT,
          |   latitude REAL,
          |   longitude REAL,
          |   street TEXT,
          |   isoCountryCode TEXT,
          |   country TEXT,
          |   postalCode TEXT,
          |   administrativeArea TEXT,
          |   subAdministrativeArea TEXT,
          |   locality TEXT,
          |   subLocality TEXT,
          |   thoroughfare TEXT,
          |   subThoroughfare TEXT
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS AnswerSelectionTable (
          |   id TEXT PRIMARY KEY NOT NULL,
          |   answerId TEXT NOT NULL,
          |   answerSelectionId TEXT NOT NULL,
          |   answerSelectionValue TEXT NOT NULL
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS AnswerTable(
          |   id TEXT PRIMARY KEY NOT NULL,
          |   inspectionId TEXT NOT NULL,
          |   questionId TEXT NOT NULL,
          |   notes TEXT,
          |   isRequiredFileOrNotes INTEGER,
          |   answerDateIso TEXT,
          |   answerOptionId TEXT,
          |   answerText TEXT
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS InspectionTable(
          |    id TEXT PRIMARY KEY NOT NULL,
          |    templateId TEXT NOT NULL,
          |    templateName TEXT NOT NULL,
          |    vesselName TEXT,
          |    totalAnswer INTEGER NOT NULL,
          |    totalQuestion INTEGER NOT NULL,
          |    lastUpdated TEXT NOT NULL,
          |    status TEXT NOT NULL,
          |    userId TEXT NOT NULL
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS TemplateTable(
          |   id TEXT PRIMARY KEY NOT NULL,
          |   name TEXT NOT NULL,
          |   version INTEGER,
          |   publishedDate TEXT NOT NULL,
          |   numberOfPages INTEGER,
          |   numberOfSections INTEGER,
          |   numberOfQuestions INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS TemplatePageTable(
          |   id TEXT PRIMARY KEY NOT NULL,
          |   templateId TEXT NOT NULL,
          |   title TEXT NOT NULL,
          |   orderPosition INTEGER NOT NULL,
          |
          |   FOREIGN KEY(templateId) REFERENCES TemplateTable(id) ON DELETE CASCADE
          |)
          """.trimMargin(), 0)
      driver.execute(null, "CREATE INDEX IF NOT EXISTS idx_template_page_template_id ON TemplatePageTable(templateId)", 0)
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS TemplatePageSectionTable(
          |    id TEXT PRIMARY KEY NOT NULL,
          |    pageId TEXT NOT NULL,
          |    title TEXT NOT NULL,
          |    orderPosition INTEGER NOT NULL,
          |
          |    FOREIGN KEY(pageId) REFERENCES TemplatePageTable(id) ON DELETE CASCADE
          |)
          """.trimMargin(), 0)
      driver.execute(null, "CREATE INDEX IF NOT EXISTS idx_template_page_section_page_id ON TemplatePageSectionTable(pageId)", 0)
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS TemplatePageSectionQuestionTable(
          |    id TEXT PRIMARY KEY NOT NULL,
          |    sectionId TEXT NOT NULL,
          |    questionText TEXT NOT NULL,
          |    guidelines TEXT,
          |    required INTEGER,
          |    orderPosition INTEGER NOT NULL,
          |    answerType TEXT NOT NULL,
          |    failedOptionId TEXT,
          |    neutralOptionId TEXT,
          |
          |    FOREIGN KEY(sectionId) REFERENCES TemplatePageSectionTable(id) ON DELETE CASCADE
          |)
          """.trimMargin(), 0)
      driver.execute(null, "CREATE INDEX IF NOT EXISTS idx_template_page_section_question_section_id ON TemplatePageSectionQuestionTable(sectionId)", 0)
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS TemplateOptionTable  (
          |    id TEXT PRIMARY KEY NOT NULL,
          |    orderPosition INTEGER NOT NULL,
          |    label TEXT NOT NULL,
          |    answerType TEXT NOT NULL
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS VesselTable(
          |    id TEXT PRIMARY KEY NOT NULL,
          |    name TEXT NOT NULL
          |)
          """.trimMargin(), 0)
      driver.execute(null, "ALTER TABLE InspectionTable ADD COLUMN conducted TEXT", 0)
      driver.execute(null, "ALTER TABLE AnswerTable ADD COLUMN lastUpdated TEXT", 0)
      driver.execute(null, "ALTER TABLE AnswerTable ADD COLUMN isSubmitted INTEGER", 0)
      driver.execute(null, "ALTER TABLE AnswerTable ADD COLUMN findingCategory TEXT", 0)
      driver.execute(null, "ALTER TABLE TemplateTable ADD COLUMN status TEXT NOT NULL DEFAULT 'PUBLISHED'", 0)
      driver.execute(null, "ALTER TABLE AnswerFileTable ADD COLUMN hasGenerateChunk INTEGER", 0)
      return QueryResult.Unit
    }

    private fun migrateInternal(
      driver: SqlDriver,
      oldVersion: Long,
      newVersion: Long,
    ): QueryResult.Value<Unit> {
      if (oldVersion <= 1 && newVersion > 1) {
        driver.execute(null, """
            |CREATE TABLE IF NOT EXISTS AnswerChunkFileTable (
            |   id TEXT PRIMARY KEY NOT NULL,
            |   answerFileId TEXT NOT NULL,
            |   fileName TEXT,
            |   originalFileName TEXT,
            |   chunkIndex INTEGER,
            |   chunk BLOB,
            |   fileSize INTEGER,
            |   chunkSize INTEGER,
            |   totalFiles INTEGER
            |)
            """.trimMargin(), 0)
        driver.execute(null, """
            |CREATE TABLE IF NOT EXISTS AnswerFileTable (
            |   id TEXT PRIMARY KEY NOT NULL,
            |   answerId TEXT NOT NULL,
            |   name TEXT NOT NULL,
            |   originalName TEXT,
            |   path TEXT,
            |   size INTEGER,
            |   type TEXT,
            |   blob BLOB,
            |   uploadStatus TEXT
            |)
            """.trimMargin(), 0)
        driver.execute(null, """
            |CREATE TABLE IF NOT EXISTS AnswerLocationTable (
            |   id TEXT PRIMARY KEY NOT NULL,
            |   answerId TEXT NOT NULL,
            |   name TEXT,
            |   latitude REAL,
            |   longitude REAL,
            |   street TEXT,
            |   isoCountryCode TEXT,
            |   country TEXT,
            |   postalCode TEXT,
            |   administrativeArea TEXT,
            |   subAdministrativeArea TEXT,
            |   locality TEXT,
            |   subLocality TEXT,
            |   thoroughfare TEXT,
            |   subThoroughfare TEXT
            |)
            """.trimMargin(), 0)
        driver.execute(null, """
            |CREATE TABLE IF NOT EXISTS AnswerSelectionTable (
            |   id TEXT PRIMARY KEY NOT NULL,
            |   answerId TEXT NOT NULL,
            |   answerSelectionId TEXT NOT NULL,
            |   answerSelectionValue TEXT NOT NULL
            |)
            """.trimMargin(), 0)
        driver.execute(null, """
            |CREATE TABLE IF NOT EXISTS AnswerTable(
            |   id TEXT PRIMARY KEY NOT NULL,
            |   inspectionId TEXT NOT NULL,
            |   questionId TEXT NOT NULL,
            |   notes TEXT,
            |   isRequiredFileOrNotes INTEGER,
            |   answerDateIso TEXT,
            |   answerOptionId TEXT,
            |   answerText TEXT
            |)
            """.trimMargin(), 0)
        driver.execute(null, """
            |CREATE TABLE IF NOT EXISTS InspectionTable(
            |    id TEXT PRIMARY KEY NOT NULL,
            |    templateId TEXT NOT NULL,
            |    templateName TEXT NOT NULL,
            |    vesselName TEXT,
            |    totalAnswer INTEGER NOT NULL,
            |    totalQuestion INTEGER NOT NULL,
            |    lastUpdated TEXT NOT NULL,
            |    status TEXT NOT NULL,
            |    userId TEXT NOT NULL
            |)
            """.trimMargin(), 0)
        driver.execute(null, """
            |CREATE TABLE IF NOT EXISTS TemplateTable(
            |   id TEXT PRIMARY KEY NOT NULL,
            |   name TEXT NOT NULL,
            |   version INTEGER,
            |   publishedDate TEXT NOT NULL,
            |   numberOfPages INTEGER,
            |   numberOfSections INTEGER,
            |   numberOfQuestions INTEGER
            |)
            """.trimMargin(), 0)
        driver.execute(null, """
            |CREATE TABLE IF NOT EXISTS TemplatePageTable(
            |   id TEXT PRIMARY KEY NOT NULL,
            |   templateId TEXT NOT NULL,
            |   title TEXT NOT NULL,
            |   orderPosition INTEGER NOT NULL,
            |
            |   FOREIGN KEY(templateId) REFERENCES TemplateTable(id) ON DELETE CASCADE
            |)
            """.trimMargin(), 0)
        driver.execute(null, "CREATE INDEX IF NOT EXISTS idx_template_page_template_id ON TemplatePageTable(templateId)", 0)
        driver.execute(null, """
            |CREATE TABLE IF NOT EXISTS TemplatePageSectionTable(
            |    id TEXT PRIMARY KEY NOT NULL,
            |    pageId TEXT NOT NULL,
            |    title TEXT NOT NULL,
            |    orderPosition INTEGER NOT NULL,
            |
            |    FOREIGN KEY(pageId) REFERENCES TemplatePageTable(id) ON DELETE CASCADE
            |)
            """.trimMargin(), 0)
        driver.execute(null, "CREATE INDEX IF NOT EXISTS idx_template_page_section_page_id ON TemplatePageSectionTable(pageId)", 0)
        driver.execute(null, """
            |CREATE TABLE IF NOT EXISTS TemplatePageSectionQuestionTable(
            |    id TEXT PRIMARY KEY NOT NULL,
            |    sectionId TEXT NOT NULL,
            |    questionText TEXT NOT NULL,
            |    guidelines TEXT,
            |    required INTEGER,
            |    orderPosition INTEGER NOT NULL,
            |    answerType TEXT NOT NULL,
            |    failedOptionId TEXT,
            |    neutralOptionId TEXT,
            |
            |    FOREIGN KEY(sectionId) REFERENCES TemplatePageSectionTable(id) ON DELETE CASCADE
            |)
            """.trimMargin(), 0)
        driver.execute(null, "CREATE INDEX IF NOT EXISTS idx_template_page_section_question_section_id ON TemplatePageSectionQuestionTable(sectionId)", 0)
        driver.execute(null, """
            |CREATE TABLE IF NOT EXISTS TemplateOptionTable  (
            |    id TEXT PRIMARY KEY NOT NULL,
            |    orderPosition INTEGER NOT NULL,
            |    label TEXT NOT NULL,
            |    answerType TEXT NOT NULL
            |)
            """.trimMargin(), 0)
        driver.execute(null, """
            |CREATE TABLE IF NOT EXISTS VesselTable(
            |    id TEXT PRIMARY KEY NOT NULL,
            |    name TEXT NOT NULL
            |)
            """.trimMargin(), 0)
      }
      if (oldVersion <= 2 && newVersion > 2) {
        driver.execute(null, "ALTER TABLE InspectionTable ADD COLUMN conducted TEXT", 0)
      }
      if (oldVersion <= 3 && newVersion > 3) {
        driver.execute(null, "ALTER TABLE AnswerTable ADD COLUMN lastUpdated TEXT", 0)
      }
      if (oldVersion <= 4 && newVersion > 4) {
        driver.execute(null, "ALTER TABLE AnswerTable ADD COLUMN isSubmitted INTEGER", 0)
      }
      if (oldVersion <= 5 && newVersion > 5) {
        driver.execute(null, "ALTER TABLE AnswerTable ADD COLUMN findingCategory TEXT", 0)
      }
      if (oldVersion <= 6 && newVersion > 6) {
        driver.execute(null, "ALTER TABLE TemplateTable ADD COLUMN status TEXT NOT NULL DEFAULT 'PUBLISHED'", 0)
      }
      if (oldVersion <= 7 && newVersion > 7) {
        driver.execute(null, "ALTER TABLE AnswerFileTable ADD COLUMN hasGenerateChunk INTEGER", 0)
      }
      return QueryResult.Unit
    }

    override fun migrate(
      driver: SqlDriver,
      oldVersion: Long,
      newVersion: Long,
      vararg callbacks: AfterVersion,
    ): QueryResult.Value<Unit> {
      var lastVersion = oldVersion

      callbacks.filter { it.afterVersion in oldVersion until newVersion }
      .sortedBy { it.afterVersion }
      .forEach { callback ->
        migrateInternal(driver, oldVersion = lastVersion, newVersion = callback.afterVersion + 1)
        callback.block(driver)
        lastVersion = callback.afterVersion + 1
      }

      if (lastVersion < newVersion) {
        migrateInternal(driver, lastVersion, newVersion)
      }
      return QueryResult.Unit
    }
  }
}
